import Link from '@material-ui/core/Link'
import MenuItem from '@material-ui/core/MenuItem'

const MenuItems = ({ onModal }) => {
  return (
    <div>
      <MenuItem>
        <Link target="_blank" href="../../reglamento/Reglas%20y%20Condiciones%202023.pdf">
          Reglamentos de Juego
        </Link>
      </MenuItem>
      <MenuItem>
        <Link target="_blank" href="https://ver.superpoolhipico.com/">
          Resultados
        </Link>
      </MenuItem>
      <MenuItem>
        <Link target="">Contacto</Link>
      </MenuItem>
      <MenuItem onClick={() => onModal(true)}>Software</MenuItem>
      <MenuItem>
        <Link target="_blank" href="../../politicas/policy.pdf">
          Política de Privacidad
        </Link>
      </MenuItem>
      
    </div>
  )
}

export default MenuItems
